import {
  getFirestore,
  onSnapshot,
  doc,
  getDocs,
  getDoc,
  setDoc,
  collection,
  serverTimestamp,
  where,
  query,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import lodash from "lodash";
import { TYPES } from "./staff.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------------------- snapStaff --------------------------
let staffInfo = [];
export const snapStaff = (callback) => (dispatch) => {
  const cRef = collection(firestore, REF.STAFF);
  const uid = auth?.currentUser?.uid;
  const c0 = where("staff", "==", uid);
  const c1 = where("active", "==", true);
  const qRef = query(cRef, c0, c1);
  // snapshot
  const unSub = onSnapshot(qRef, (snapshot) => {
    if (snapshot.docs.length === 0) {
      getActiveSuccess(dispatch, false);
      if (callback) {
        callback();
      }
    } else {
      getActiveSuccess(dispatch, true);
      if (callback) {
        callback();
      }
    }
  });
  staffInfo.push(unSub);
};

export const unSnapStaff = () => (dispatch) => {
  staffInfo.forEach((subscriber) => {
    subscriber();
  });
  staffInfo.length = 0;
};

// -------------------------- Snapshot --------------------------
let staffSub = [];
export const snapStaffs =
  ({ branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c1);
    // snapshot
    const unSub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        getStaffSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    staffSub.push(unSub);
  };

export const unSnapStaffs = () => (dispatch) => {
  staffSub.forEach((subscriber) => {
    subscriber();
  });
  staffSub.length = 0;
};

// -------------------------- Snapshot --------------------------

export const getStaffByIds =
  ({ ids }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.USER);
    let result = [];

    const promises = lodash.chunk(ids, 10)?.map((item) => {
      const c1 = where("id", "in", item);
      const qRef = query(cRef, c1);
      return getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data()) || [];
          const sorted = lodash.sortBy(data, (x) => {
            return lodash.indexOf(item, x.ids);
          });
          result.push(...sorted);
        }
      });
    });
    Promise.all(promises)
      .then(() => {
        getStaffsInfoSuccess(dispatch, result);
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: JSON.stringify(error),
          });
        }
      });
  };

export const emptyStaffs = (callback) => (dispatch) => {
  getStaffsInfoSuccess(dispatch, []);
};

// -------------------------- Find Staff --------------------------
export const findStaff =
  ({ phone }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.USER);
    const c1 = where("phone", "==", phone);
    const qRef = query(cRef, c1);
    getSearchSuccess(dispatch, null);
    return getDocs(qRef)
      .then((snapshot) => {
        if (snapshot.docs.length > 0) {
          const data = snapshot.docs.map((doc) => doc.data());
          getSearchSuccess(dispatch, data);
          if (callback) {
            callback({
              status: 200,
            });
          }
        } else {
          if (callback) {
            callback({
              status: 500,
              data: "Phone number not found",
            });
          }
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error,
          });
        }
      });
  };

export const resetFind = (callback) => (dispatch) => {
  getSearchSuccess(dispatch, []);
};

// -------------------------- Add Staff --------------------------

export const addStaff =
  ({ branch, staff }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const uid = auth?.currentUser?.uid;
    const data = {
      id,
      branch: branch.id,
      owner: branch.owner,
      addBy: uid,
      staff,
      active: true,
      createAt: serverTimestamp(),
    };
    setDoc(dRef, data, { merge: true })
      .then(() => {
        callback({
          status: 200,
        });
      })
      .then((error) => {
        callback({
          status: 500,
          data: error,
        });
      });
  };

// -------------------------- Remove Staff --------------------------
export const deleteStaff =
  ({ staff }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const id = staff.id;
    const dRef = doc(cRef, id);
    deleteDoc(dRef)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// -------------------------- Update   --------------------------

export const updateStaff =
  ({ staff, update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const id = staff.staffId;
    const dRef = doc(cRef, id);
    updateDoc(dRef, update)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// ------------- get info staff by userId -----------------------
let infoStaffSub = [];
export const getInfoDetailByUserId =
  ({ userId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.USER);
    const c0 = where("id", "==", userId);
    const qRef = query(cRef, c0);

    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const [data] = snapshot.docs.map((doc) => doc.data());
        selectDetailInfoSuccess(dispatch, data);
        if (callback) {
          callback({
            status: 200,
          });
        }
      }
    });

    infoStaffSub.push(unsub);
  };

export const unSnapStaffInfo = () => (dispatch) => {
  infoStaffSub.forEach((subscriber) => {
    subscriber();
  });

  infoStaffSub.length = 0;
};

// ------------- get staff detail by userId --------------------
export const getStaffDetailByUserId =
  ({ userId, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const c0 = where("staff", "==", userId);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef)
      .then((snapshot) => {
        if (snapshot) {
          const [data] = snapshot.docs.map((doc) => doc.data());
          selectDetailSuccess(dispatch, data);
          if (callback) {
            callback({
              status: 200,
            });
          }
        }
      })
      .catch((error) => {
        callback({
          status: 500,
          data: error,
        });
      });
  };

// ----------------- update Staff info ----------------
export const updateStaffInfo =
  ({ update, active, detail, currentUser }, callback) =>
  (dispatch) => {
    const cRefUser = collection(firestore, REF.USER);
    const cRefStaff = collection(firestore, REF.STAFF);
    const staffId = detail?.id;
    const userId = detail?.staff;
    let oldIrd = currentUser?.ird;
    oldIrd = oldIrd?.toString();
    const ird = update?.ird;

    console.log({ oldIrd });

    //Check duplicate IRD number
    const c0 = where("ird", "==", ird);
    const qRef = query(cRefUser, c0);
    getDocs(qRef).then((snapshot) => {
      if (ird === oldIrd || snapshot?.docs?.length === 0) {
        //updateInfo
        const dRefStaff = doc(cRefStaff, staffId);
        updateDoc(dRefStaff, { active }).then(() => {});

        //update Active
        const dRefInfo = doc(cRefUser, userId);
        updateDoc(dRefInfo, update)
          .then(() => {
            if (callback) {
              callback({
                status: 200,
              });
            }
          })
          .catch((err) => {
            if (callback) {
              callback({
                status: 500,
                data: err,
              });
            }
          });
      } else {
        callback({
          status: 500,
          data: "Duplicate IRD Number",
        });
      }
    });
  };

// ------------------------ grant Access for Staff/ POS --------------------------
export const updatePosAccessStaff =
  ({ staffs, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.STAFF);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c1);

    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data?.length > 0) {
          data.forEach((item) => {
            const id = item?.id;
            const staff = item?.staff;
            const result = staffs?.includes(staff) ? true : false;
            const dRef = doc(cRef, id);
            return updateDoc(dRef, { pos: result });
          });
        }
      }
    });
  };

// -------------------------- Dispatch --------------------------
const getStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFFS_SUCCESS,
    payload: data,
  });
};

const getStaffsInfoSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFFS_INFO_SUCCESS,
    payload: data,
  });
};

const getSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_SEARCH_SUCCESS,
    payload: data,
  });
};

const selectDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DETAIL_STAFF_SUCCESS,
    payload: data,
  });
};

const selectDetailInfoSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DETAIL_INFO_STAFF_SUCCESS,
    payload: data,
  });
};

const getActiveSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFF_ACTIVE_SUCCESS,
    payload: data,
  });
};

// -------------- get Staff by ids -------------
export const getStaffsByIds =
  ({ ids }, callback) =>
  (dispatch) => {
    selectStaffSuccess(dispatch, null);
    const cRef = collection(firestore, REF.USER);
    let result = [];
    const promises = lodash.chunk(ids, 9)?.map((arr) => {
      const c0 = where("id", "in", arr);
      const qRef = query(cRef, c0);
      return getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          result.push(...data);
        }
      });
    });

    Promise.all(promises)
      .then(() => {
        selectStaffSuccess(dispatch, result);
        if (callback) {
          callback({
            status: 200,
            data: result,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message,
          });
        }
      });
  };

// dispatch
const selectStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFF_SUCCESS,
    payload: data,
  });
};

// snap all staff
let allSub = [];
export const snapAllStaffs = (callback) => (dispatch) => {
  snapAllStaffSuccess(dispatch, null);
  const cRef = collection(firestore, REF.STAFF);
  const c0 = where("active", "==", true);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      snapAllStaffSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allSub.push(unsub);
};

export const UnSnapAllStaff = () => (dispatch) => {
  allSub.forEach((subscriber) => {
    subscriber();
  });

  allSub.length = 0;
};

// dispatch
const snapAllStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SNAP_ALL_STAFF_SUCCESS,
    payload: data,
  });
};
